// extracted by mini-css-extract-plugin
module.exports = {"container":"walletEmpty_container__2D-28","image":"walletEmpty_image__36Dck","message":"walletEmpty_message__FJ8pJ","refresh":"walletEmpty_refresh__38eE4"};